export const KeysOfProviderForLanguage = ['title', 'quote'];
